import { render } from "./AccommodationExperiencesSection.vue?vue&type=template&id=72664618&scoped=true&ts=true"
import script from "./AccommodationExperiencesSection.vue?vue&type=script&lang=ts"
export * from "./AccommodationExperiencesSection.vue?vue&type=script&lang=ts"

import "./AccommodationExperiencesSection.vue?vue&type=style&index=0&id=72664618&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72664618"]])

export default __exports__